import React, { useState, useEffect } from "react";
import logo from "../assets/vignan_online.png";
import axios from "axios";
import { useAuth } from "../Context/AuthContext.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { useCampaign } from '../Context/CampaignContext.jsx';

const Login = () => {
  const [otpStatus, setOtpStatus] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [emailSuccessMessage, setEmailSuccessMessage] = useState("");
  const [resendOtpDisabled, setResendOtpDisabled] = useState(true); // Manage resend OTP button state
  const [countdown, setCountdown] = useState(60); // Timer for resend OTP
  const [error, setError] = useState("");
  const [usererror, setUsererror] = useState("");
  const [toggle, setToggle] = useState(false);
  const [phone, setPhone] = useState("");
  const [token, setToken] = useState("");
  const [tempuser, setTempuser] = useState([]);
  const [alertShown, setAlertShown] = useState(false);
  const { setUser, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { saveCampaignData } = useCampaign();
  const { utm_campaign, utm_source, utm_medium } = location.state || {};
  const [toggleUi, setToggleUi] = useState(false)
  const [phonelogin, setPhonelogin] = useState("")
  const [phoneSuccessMessage, setPhoneSuccessMessage] = useState("")
  const [phoneotpstatus, setPhoneOtpStatus] = useState(false)
  const [phoneMessageError, setPhoneMessageErorr] = useState("")
  const [phonePassword, setPhonePassword] = useState("")


  const getQueryParams = (key) => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  const campaign = getQueryParams("utm_campaign") || utm_campaign || "NA";
  const source = getQueryParams("utm_source") || utm_source || "NA";
  const medium = getQueryParams("utm_medium") || utm_medium || "NA"

  useEffect(() => {
    saveCampaignData(source, campaign, medium);
  }, [source, campaign, medium, saveCampaignData]);

  useEffect(() => {
    const { utm_campaign, utm_source, utm_medium } = location.state || {};

    // Only call saveCampaignData if it's not already set
    if (utm_campaign || utm_source || utm_medium) {
      saveCampaignData(utm_source || "NA", utm_campaign || "NA", utm_medium || "NA");
    }
  }, [location.state, saveCampaignData]);


  // Effect to handle the countdown timer
  useEffect(() => {
    let timer;
    if (resendOtpDisabled && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (countdown === 0) {
      setResendOtpDisabled(false); // Re-enable the resend OTP button after countdown finishes
    }

    return () => clearTimeout(timer); // Cleanup the timer when component unmounts or countdown changes
  }, [countdown, resendOtpDisabled]);

  async function sentmobileOtp(e) {
    e.preventDefault();
    await axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/users/generatePhoneOtp`, {
        phone: phonelogin
      })
      .then((resp) => {
        if (resp.status === 201) {
          setPhoneSuccessMessage(resp.data.status)
          setTimeout(() => {
            setPhoneSuccessMessage("");
          }, 2000);
          setPhoneOtpStatus(true)
          setResendOtpDisabled(true);
          setCountdown(60);
        }
      })
      .catch((error) => {
        setPhoneMessageErorr(error.response.data.message)
        setTimeout(() => {
          setPhoneMessageErorr("");
        }, 2000);
      });
  }

  // Send OTP function
  async function sentOtp(e) {
    e.preventDefault();
    await axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/users/get-otp`, {
        email,
      })
      .then((resp) => {
        if (resp.status === 201) {
          setEmailSuccessMessage(resp.data.status);
          setTimeout(() => {
            setEmailSuccessMessage("");
          }, 2000);
          setOtpStatus(true);
          setResendOtpDisabled(true); // Disable resend OTP button
          setCountdown(60); // Reset countdown for 1 minute
        }
      })
      .catch((error) => {
        setUsererror(error.response.data.message);
        setTimeout(() => {
          setUsererror("");
        }, 2000);
      });
  }



  // Login function
  async function login(e) {
    e.preventDefault()
    await axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/users/validate-otp`, {
        phone_number: phonelogin,
        email,
        otp,
      })
      .then((resp) => {
        if (resp.status === 200) {
          setToken(resp.data.token)
          setTempuser(resp.data.userInfo)
          const receivedToken = resp.data.token;
          const receivedUserInfo = resp.data.userInfo;
          if (receivedUserInfo.phone_number !== null) {
            setUser(receivedUserInfo);
            localStorage.setItem("token", receivedToken);
            const redirectTo = location.state?.from?.pathname ?? (receivedUserInfo.user_type === "Admin" || receivedUserInfo.user_type === "SalesHead" || receivedUserInfo.user_type === "DepartmentHead" || receivedUserInfo.user_type === "SalesCounselor" ? "/sales" : "/student");
            navigate(redirectTo, { replace: true, });
          } else {
            setToggle(true)
          }
        }
      })
      .catch((error) => {
        setError(error.response.data.message);
        setTimeout(() => {
          setError("");
        }, 2000);
      });
  }

  const updatePhoneNumber = async (e) => {
    e.preventDefault()
    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/users/update-phone`, {
      phone_number: phone,
      id: tempuser.id
    }).then((resp) => {
      localStorage.setItem("token", token);
      setUser(tempuser);
      if (resp.status === 201) {
        const redirectTo = location.state?.from?.pathname ?? (tempuser.user_type === "Admin" || tempuser.user_type === "SalesHead" || tempuser.user_type === "DepartmentHead" || tempuser.user_type === "SalesCounselor" ? "/sales" : "/student");
        navigate(redirectTo, { replace: true, });

      }
    }).catch((error) => {
      console.log(error)
    })
  }
  function handletogglePhone() {
    setToggleUi(true)
    setPhonelogin("")
    setPhoneOtpStatus(false)
    setResendOtpDisabled(false)
    setCountdown(0)
  }
  function handleEmailToggle() {
    setToggleUi(false)
    setEmail("")
    setOtpStatus(false)
    setResendOtpDisabled(false)
    setCountdown(0)
  }


  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden border border-gray-100 relative">

        <div className="p-8 pb-6">
          <a href="/" className="block w-max mx-auto mb-8 transition-transform hover:scale-105 duration-300">
            <img src={logo} alt="Vignan Online" className="h-12 object-contain" />
          </a>

          {!toggle ? (
            <>
              <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">Welcome Back</h2>
              <p className="text-center text-gray-500 mb-8 text-sm">Login to access your dashboard</p>

              {/* Enhanced Segmented Control */}
              <div className="bg-gray-100 p-1 rounded-xl flex mb-8 relative">
                <TogglePill active={!toggleUi} onClick={handleEmailToggle} icon={
                  <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                }>
                  Email Address
                </TogglePill>
                <TogglePill active={toggleUi} onClick={handletogglePhone} icon={
                  <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                }>
                  Mobile Number
                </TogglePill>

              </div>

              {toggleUi ? (
                // PHONE LOGIN
                <div className="space-y-6">
                  <form onSubmit={sentmobileOtp} className="space-y-4">
                    {!phoneotpstatus && (
                      <>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1 ml-1 text-left">Mobile Number</label>
                          <InputField
                            type="text"
                            value={phonelogin}
                            onChange={(e) => {
                              const input = e.target.value.replace(/\D/g, "");
                              if (input.length <= 10) {
                                setPhonelogin(input);
                              }
                            }}
                            placeholder="Enter 10-digit number"
                            required
                          />
                        </div>
                        <PrimaryButton type="submit">
                          Send Verification Code
                        </PrimaryButton>
                      </>
                    )}
                    {phoneMessageError && <div className="text-red-500 text-sm text-center bg-red-50 py-2 rounded">{phoneMessageError}</div>}
                  </form>

                  {phoneSuccessMessage && (
                    <div className="text-green-600 text-sm text-center bg-green-50 py-2 rounded">{phoneSuccessMessage}</div>
                  )}

                  {phoneotpstatus && (
                    <form onSubmit={login} className="space-y-4 animate-fadeIn">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1 ml-1 text-left">One-Time Password</label>
                        <InputField
                          type="text"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          placeholder="Enter OTP"
                          required
                          maxLength={6}
                        />
                      </div>

                      <div className="flex flex-col gap-3 pt-2">
                        <PrimaryButton type="submit">
                          Login
                        </PrimaryButton>

                        <SecondaryButton
                          onClick={sentmobileOtp}
                          disabled={resendOtpDisabled}
                        >
                          {resendOtpDisabled ? `Resend code in ${countdown}s` : "Resend Code"}
                        </SecondaryButton>
                      </div>
                    </form>
                  )}
                </div>
              ) : (
                // EMAIL LOGIN
                <div className="space-y-6">
                  <form onSubmit={sentOtp} className="space-y-4">
                    {!otpStatus && (
                      <>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1 ml-1 text-left">Email Address</label>
                          <InputField
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value.toLowerCase())}
                            placeholder="yourname@example.com"
                            required
                          />
                        </div>
                        <PrimaryButton type="submit">
                          Send Verification Code
                        </PrimaryButton>
                      </>
                    )}
                    {usererror && <div className="text-red-500 text-sm text-center bg-red-50 py-2 rounded">{usererror}</div>}
                  </form>

                  {emailSuccessMessage && (
                    <div className="text-green-600 text-sm text-center bg-green-50 py-2 rounded">{emailSuccessMessage}</div>
                  )}

                  {otpStatus && (
                    <form onSubmit={login} className="space-y-4 animate-fadeIn">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1 ml-1 text-left">One-Time Password</label>
                        <InputField
                          type="text"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          placeholder="Enter OTP"
                          required
                          maxLength={6}
                        />
                      </div>

                      <div className="flex flex-col gap-3 pt-2">
                        <PrimaryButton type="submit">
                          Login
                        </PrimaryButton>
                        <SecondaryButton
                          onClick={sentOtp}
                          disabled={resendOtpDisabled}
                        >
                          {resendOtpDisabled ? `Resend code in ${countdown}s` : "Resend Code"}
                        </SecondaryButton>
                      </div>
                    </form>
                  )}
                  {error && <div className="text-red-500 text-sm text-center bg-red-50 py-2 rounded">{error}</div>}
                </div>
              )}

              <div className="mt-8 text-center">
                <p className="text-gray-500 text-sm">
                  Don't have an account?{' '}
                  <a href="/register" className="text-red-600 font-semibold hover:text-red-700 transition-colors">
                    Register Now
                  </a>
                </p>
              </div>
            </>
          ) : (
            // UPDATE PHONE NUMBER STATE
            <div className="animate-fadeIn">
              <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">Details Required</h2>
              <p className="text-center text-gray-500 mb-8 text-sm">Please provide your contact number to continue</p>

              <form onSubmit={updatePhoneNumber} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1 ml-1 text-left">Phone Number</label>
                  <InputField
                    type="text"
                    value={phone}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setPhone(value);
                      }
                      setAlertShown(false);
                    }}
                    onBlur={() => {
                      if (phone.length !== 10 && !alertShown) {
                        alert("Phone number must be exactly 10 digits");
                        setPhone("");
                        setAlertShown(true);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && phone.length !== 10 && !alertShown) {
                        alert("Phone number must be exactly 10 digits");
                        setPhone("");
                        setAlertShown(true);
                      }
                    }}
                    placeholder="Enter 10-digit number"
                    maxLength={10}
                    required
                  />
                </div>

                <PrimaryButton type="submit">
                  Update Contact Number
                </PrimaryButton>
                <div className="text-sm text-center text-amber-600 bg-amber-50 p-3 rounded border border-amber-200">
                  You will receive an OTP while redeeming points in the future.
                </div>
              </form>
            </div>
          )}
        </div>

        <div className="bg-gray-50 px-8 py-4 text-center border-t border-gray-100">
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} VIGNAN Online (Deemed to be University). All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

// Design Components
const InputField = ({ type, placeholder, value, onChange, ...props }) => (
  <input
    type={type}
    value={value}
    onChange={onChange}
    className={`w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition-all duration-200 bg-gray-50 focus:bg-white placeholder-gray-400 text-gray-800 ${props.className || ''}`}
    placeholder={placeholder}
    {...props}
  />
);

const PrimaryButton = ({ children, onClick, disabled, className, type = "submit" }) => (
  <button
    onClick={onClick}
    type={type}
    disabled={disabled}
    className={`w-full py-3 px-4 rounded-lg bg-red-600 hover:bg-red-700 text-white font-semibold shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none flex justify-center items-center ${className || ''}`}
  >
    {children}
  </button>
);

const SecondaryButton = ({ children, onClick, disabled, className, type = "button" }) => (
  <button
    onClick={onClick}
    type={type}
    disabled={disabled}
    className={`w-full py-3 px-4 rounded-lg bg-white border border-red-500 text-red-600 font-semibold hover:bg-red-50 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${className || ''}`}
  >
    {children}
  </button>
);

const TogglePill = ({ active, onClick, children, icon }) => (
  <button
    onClick={onClick}
    className={`flex-1 py-2.5 px-4 text-sm font-semibold rounded-lg transition-all duration-300 flex items-center justify-center ${active
      ? "bg-white text-gray-900 shadow-[0_2px_8px_rgba(0,0,0,0.08)] ring-1 ring-black/5"
      : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
      }`}
  >
    {icon}
    {children}
  </button>
);

export default Login;
